import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=67fb17ae"
import script from "./submit.js?vue&type=script&lang=js&external"
export * from "./submit.js?vue&type=script&lang=js&external"
import style0 from "./submit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports